import { Button, List } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CourseTime } from '../../components/CourseTime';
import { EmptyState } from '../../components/EmptyState';
import { StatusBadge } from '../../components/StatusBadge';
import { coursesApi, notificationsApi, requestsApi } from '../../services/resources';
import type { Course, ExperimentRequest, NotificationItem } from '../../types/api';

export function StudentHomePage() {
  const nav = useNavigate();
  const [reqs, setReqs] = useState<ExperimentRequest[]>([]);
  const [courses, setCourses] = useState<Course[]>([]);
  const [notes, setNotes] = useState<NotificationItem[]>([]);
  const [unread, setUnread] = useState(0);
  const [error, setError] = useState('');

  useEffect(() => {
    Promise.all([
      requestsApi.list({ page: 1, limit: 10 }),
      coursesApi.list({ page: 1, limit: 2, status: 'published' }),
      notificationsApi.list(),
      notificationsApi.unread(),
    ])
      .then(([r, c, n, u]) => {
        setReqs(r.items);
        setCourses(c.items);
        setNotes(n.items);
        setUnread(u.count ?? 0);
      })
      .catch(() => setError('本周暂无开放实验室名额，请查看通知或下周一再来。'));
  }, []);

  return (
    <div className="stack">
      <h1 className="page-title">首页</h1>
      <section className="surface" style={{ padding: 16 }}>
        <h2>待办</h2>
        {reqs.map((r) => (
          <div key={r.id} className="row">
            <StatusBadge status={r.status} reasonType={r.reason_type} />
            {r.title}
          </div>
        ))}
        <p className="meta">未读通知 {unread}</p>
        {notes.slice(0, 3).map((n) => (
          <p key={n.id}>{n.title ?? n.body}</p>
        ))}
      </section>
      <section>
        <h2>本周开放课</h2>
        {error && courses.length === 0 ? <EmptyState text={error} /> : null}
        {courses.length === 0 && !error ? (
          <EmptyState text="本周暂无开放实验室名额，请查看通知或下周一再来。" />
        ) : (
          <List
            dataSource={courses}
            renderItem={(c) => (
              <List.Item>
                <Link to="/student/courses">{c.title}</Link>
                <CourseTime course={c} compact />
              </List.Item>
            )}
          />
        )}
      </section>
      <Button type="primary" className="touch" onClick={() => nav('/student/requests/new')}>
        自主实验申请（2 个工作日反馈）
      </Button>
    </div>
  );
}
